import { render, staticRenderFns } from "./DeviceExcursion.vue?vue&type=template&id=2e21e682&scoped=true"
import script from "./DeviceExcursion.vue?vue&type=script&lang=js"
export * from "./DeviceExcursion.vue?vue&type=script&lang=js"
import style0 from "./DeviceExcursion.vue?vue&type=style&index=0&id=2e21e682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e21e682",
  null
  
)

/* custom blocks */
import block0 from "./DeviceExcursion.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports